import { all } from "redux-saga/effects";
import * as watchers from "./watchers";

export function* dashboardSagas() {
  yield all([
    watchers.watchFetchAllDashboardData(),
    watchers.watchFetchCourseCompletionAnalytics(),
    watchers.watchLoadAllCourses(),
    watchers.watchLoadMoreCourses(),
    watchers.watchSearchCoursesByName(),
    watchers.watchMount(),
    watchers.watchUnmount(),
  ]);
}
